export default __webpack_public_path__ + "static/media/attendance.1c3ab3a8.jpg";